import React from "react";
import ListBox from "@ingka/list-box";
import { useState, useRef, useEffect } from "react";

type ListBoxContainerProps = {
  renderTrigger: (toggleFn: () => void) => React.ReactNode;
  renderChildren: () => React.ReactNode;
};

export function ListBoxContainer({
  renderTrigger,
  renderChildren,
}: ListBoxContainerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const listBoxRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        listBoxRef.current &&
        !listBoxRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={listBoxRef}>
      <ListBox
        open={isOpen}
        trigger={renderTrigger(() => setIsOpen((prev) => !prev))}
      >
        {renderChildren()}
      </ListBox>
    </div>
  );
}
